// IMPORTANT: must match the domain that actually serves the site.
export const SITE_URL = "https://arandialawfirm.com";

export const LOCALES = ["en", "pt", "es"] as const;
export type Locale = (typeof LOCALES)[number];

const LOCALE_RE = /^\/(en|pt|es)(?=\/|$)/i;

/** "/pt/contact" -> "/contact" ; "/pt" -> "/" ; "/contact" -> "/contact" */
export const stripLocalePrefix = (pathname: string): string => {
  const stripped = pathname.replace(LOCALE_RE, "");
  return stripped === "" ? "/" : stripped;
};

/** Unprefixed paths are English. */
export const getLocaleFromPath = (pathname: string): Locale => {
  const m = pathname.match(LOCALE_RE);
  return m ? (m[1].toLowerCase() as Locale) : "en";
};

/**
 * Builds an absolute URL for a locale.
 * English lives at the root with NO /en prefix — this matches generate-sitemap.cjs.
 */
/**
 * Prefixos de landing page de tráfego pago.
 *
 * Mora aqui, e não dentro do SEOHead, porque duas coisas distintas precisam da
 * mesma resposta: o SEOHead, para emitir noindex, e o StickyActionBar, para não
 * oferecer link de saída numa página paga. Em arquivos separados as duas listas
 * divergiriam na primeira LP nova.
 *
 * Recebe o caminho JÁ sem o prefixo de idioma (stripLocalePrefix), senão
 * /pt/lp/queens não casa.
 */
export const PAID_LANDING_PREFIXES = ["/lp/"] as const;

export const isPaidLandingPath = (cleanPath: string): boolean =>
  PAID_LANDING_PREFIXES.some((p) => cleanPath.startsWith(p));

/**
 * Tudo que não deve ser indexado. Além das LPs pagas, entra aqui /web, que é
 * só o WebRedirector: ele devolve <Navigate> para a URL sem o /web, mas o
 * SEOHead roda antes disso no I18nLayout e, como /web não existe no PAGE_META,
 * a rota saía emitindo a meta da HOME e um canonical próprio para uma URL que
 * nem deveria ser rastreada.
 *
 * Note que a resposta é noindex, e NÃO "não emitir a tag": a robots estática do
 * index.html tem data-rh, então uma página que não a emitisse faria o
 * updateTags() do Helmet apagá-la.
 */
const NOINDEX_PREFIXES = [...PAID_LANDING_PREFIXES, "/web"] as const;

export const isNoIndexPath = (cleanPath: string): boolean =>
  NOINDEX_PREFIXES.some((p) => cleanPath === p || cleanPath.startsWith(p));

export const buildUrl = (locale: Locale, cleanPath: string): string => {
  const prefix = locale === "en" ? "" : `/${locale}`;
  const path = cleanPath === "/" ? "/" : cleanPath.replace(/\/$/, "");
  return `${SITE_URL}${prefix}${path}`;
};
